
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Card from 'vux/src/components/card/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import store from '../../vuex/store'
import wx from 'weixin-js-sdk'
import { go } from '../../libs/router'
export default {
mounted () {
store.commit('UPDATE_TITLE', '发票夹')
store.commit('UPDATE_SHOW_FOOTER', true)
},
components: {
Group,
Cell,
Card,
CellFormPreview,
CellBox,
Alert,
Loading
},
methods: {















onClick () {
console.log('on click')
},
smsp () {
var _this = this
wx.scanQRCode({
desc: 'scanQRCode desc',
needResult: 1,
scanType: ['qrCode'],
success: function (res) {
var param = {
qrCode: res.resultStr
}
_this.loadingShow = true
_this.$ajax.post(_this.ajaxFactory.get('scanInvoice'), {}, {
params: param
}).then(function (response) {
_this.loadingShow = false
var result = response.data
if (result.code === '500') {
_this.warnMsgShow = true
_this.warnMsg = result.msg
} else if (result.source === 'piaotong') {
if (result.invoiceKind === '10') {
go('/dzfppz/' + result.invoiceBaseInfo.id, _this.$router)
} else {
go('/scptfp/' + result.invoiceBaseInfo.id, _this.$router)
}
} else {
if (result.imgSize > 0) {
go('/dzfppz/' + result.invoiceBaseInfo.id, _this.$router)
} else {
go('/scptfp/' + result.invoiceBaseInfo.id, _this.$router)
}
}
})
.catch(function (response) {
_this.loadingShow = false
console.log(response)
})
},
error: function (res) {
if (res.errMsg.indexOf('function_not_exist') > 0) {
window.alert('版本过低')
}
}
})
},
smkp () {


var _this = this
wx.scanQRCode({
desc: 'scanQRCode desc',
needResult: 1,
scanType: ['qrCode'],
success: function (res) {
var param = {
kpUrl: res.resultStr
}
_this.loadingShow = true
_this.$ajax.post(_this.ajaxFactory.get('scanInvoiceSp'), {}, {
params: param
}).then(function (response) {
_this.loadingShow = false
if (response.data.code === '500') {
_this.warnMsgShow = true
_this.warnMsg = response.data.msg
} else {
go(response.data.url, _this.$router)
}
})
.catch(function (response) {
_this.loadingShow = false
console.log(response)
})
},
error: function (res) {
if (res.errMsg.indexOf('function_not_exist') > 0) {
window.alert('版本过低')
}
}
})
},
tqmkp () {
var _this = this
_this.$ajax.post(_this.ajaxFactory.get('redirectTQMKP'), {}).then(function (response) {
window.location.href = response.data.url
})
.catch(function (response) {
console.log(response)
})
}
},
data () {
return {
loadingShow: false,
loadingText: '加载中',
showContent001: false,
wxReady: false,
invoiceTotal: {
totalAmount: 0,
count: 0
},
warnMsgShow: false,
warnMsg: '',
regist: {}
}
},
created () {
var _this = this
_this.$ajax.post(_this.ajaxFactory.get('invoiceTotal'), {}).then(function (response) {
var result = response.data
_this.invoiceTotal = result
})
.catch(function (response) {
console.log(response)
})
}
}



// WEBPACK FOOTER //
// ./src/components/fpj/index.vue